export default "__VITE_ASSET__KhynNNWo__"